import type { AdgsSweep } from '@a7y/types';

const DEFAULT_REFETCH_INTERVAL_MS = 60_000;
const UNRESOLVED_DETAILS_REFETCH_INTERVAL_MS = 10_000;

/**
 * Takes the sweep ARRAY, not the queue object: the table now reads a
 * day-scoped endpoint whose payload has no `recentSweeps` field, and the fast
 * interval exists for the rows on screen rather than for whichever endpoint
 * produced them.
 */
export function getAdgsRefetchInterval(sweeps: readonly AdgsSweep[] | undefined): number {
  const hasUnresolvedSuccessfulSweep = sweeps?.some(
    (sweep) =>
      sweep.status === 'completed' &&
      sweep.conclusion === 'success' &&
      (sweep.evaluatedCount == null || sweep.dispatchedTicketIds == null)
  );
  return hasUnresolvedSuccessfulSweep
    ? UNRESOLVED_DETAILS_REFETCH_INTERVAL_MS
    : DEFAULT_REFETCH_INTERVAL_MS;
}
